import { ItemType } from '@afterpaytouch/portal-api'

export const DISPLAYABLE_ITEM_TYPES: ItemType[] = [ItemType.PRODUCT, ItemType.ACCESSORY]
